import { useNavigation, useNotification } from "@refinedev/core";

import { toHumanErrorMessage } from "@/lib/extensions/httpErrorExtension";
import { GroupForm } from "@/pages/tina/groups/components/group-form";
import { useGroupsRepository } from "@/pages/tina/groups/hooks/use-groups-repository";
import type { GroupFormType } from "@/pages/tina/groups/schemas/group.form";

export const GroupsCreate = () => {
  const repo = useGroupsRepository();
  const { list } = useNavigation();
  const { open } = useNotification();

  const onSubmit = async (values: GroupFormType) => {
    try {
      await repo.create({ ...values, updated_by: null });
      list("tina-groups");
    } catch (error) {
      open?.({
        type: "error",
        message: "Failed to create group",
        description: toHumanErrorMessage(error),
      });
    }
  };

  return (
    <div className="flex w-full max-w-6xl flex-col gap-4 p-8">
      <div>
        <h1 className="text-2xl font-semibold">Add group</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Pick a time, the weekdays it runs, and the sites it fires.
        </p>
      </div>
      <GroupForm
        defaultValues={{ name: "", time_of_day: "12:00", days_of_week: [1, 2, 3, 4, 5], sites: [], enabled: true }}
        submitLabel="Create group"
        onSubmit={onSubmit}
      />
    </div>
  );
};
